import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui/box';
import type { BoxProps } from 'components/ui/box';
import { withTypography } from 'components/ui/typography';
import { spacing } from 'styles/constants';

export const ContentContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.contentContainer, style] });

export const ModalHeading = withTypography({
  variant: 'headerOne',
  mt: '$2',
});

export const ModalBody = withTypography({ fontSize: 'md', my: '$2' });

const styles = StyleSheet.create({
  contentContainer: {
    marginBottom: spacing.$6,
  },
});
